import CollaboratorRoles from "../../../../src/courses/partials/team-management/understanding-collaborator-roles.mdx";
import * as React from 'react';
export default {
  CollaboratorRoles,
  React
};